<template>
  <div :class="$style.image">
    <BaseImage
      :src="src && src !== '' ? src : fallbackImage"
      :alt="alt"
      :fallback-image="fallbackImage"
    />
  </div>
</template>

<script>
import FallbackImage from '@/images/placeholder.png'

export default {
  name: 'BasketProductImage',
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fallbackImage: FallbackImage,
    }
  },
}
</script>

<style lang="scss" module>
.image {
  display: flex;
  align-items: center;
  justify-content: center;
  // max-width: 6rem;
  height: 100%;

  img {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      max-height: 60px;
    }
    width: auto;
    max-width: 100%;
    // max-height: 60px;
    height: auto;
  }
}
</style>
